import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import html_iway from "./template.iway.html?raw";
import { ShoppingCart, SquareMenu, University, SlidersHorizontal, Rocket } from "lucide-vue-next";
import { configsProviderKey, type ConfigsNavigationPath } from "../../../infrastructure/configs_provider";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: { ShoppingCart, SquareMenu, University, SlidersHorizontal, Rocket },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const configsProvider = inject(configsProviderKey)


    const configPathes = computed<ConfigsNavigationPath[]>(() => {
      return configsProvider?.configsPathes.value ?? [];
    })
    
    const currentWidth = computed(() => {
      let w = 0 == configPathes.value.length 
        ? 30 
        : 100 / configPathes.value.length;
      let idx = 0;
      for(let i=0; i< configPathes.value.length; i++){
        if (configPathes.value[i].path == route.path){
          idx = i;
        }
      }
      return w * (idx+1);
    })

    const currentName = computed(() => {
      for(let i=0; i< configPathes.value.length; i++){
        if (configPathes.value[i].path == route.path){
          return configPathes.value[i].title;
        }
      }
      return "ConfigsNavigation_NoConfigs";

    })

    return {
      t,
      configPathes,
      currentWidth,
      currentName,
    }
  }
}
